import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function GlobalNotificationToast({ children }: Readonly<{ children: React.ReactNode }>) {
	return (
		<>
			{children}
			<ToastContainer
				position="top-center"
				autoClose={4500}
				limit={1}
				newestOnTop
				hideProgressBar
				closeOnClick
                closeButton={false}
				pauseOnHover
				draggable={false}
				theme="dark"
                toastStyle={{
                    maxWidth: '350px',  
                    borderRadius: '18px',
                    margin: '20px',
                    backdropFilter: 'blur(10px)',
                    backgroundColor: '#151818b2', 
                    fontSize: '14px', 
                    fontWeight: 600,
                    fontFamily: 'JetBrains Mono'
                }}
			/>
		</>
	);
}